import { Transport } from '../../api/cart/interfaces'
import { Vehicle } from './Vehicles'
import {
  AvailabilityError,
  ProductLocationModel,
  ProductModel,
} from 'interfaces'
import { VehicleSpecificationCartItem } from './VehicleSpecification'
import { LaborItem } from './LaborModel'

export interface CartVehicle {
  vehicle: Vehicle
  products: Array<ShoppingCartProduct>
  quoteSourceId?: string
  orderFormData?: OrderFormData
  specifications?: Array<VehicleSpecificationCartItem>
  laborResults?: Array<LaborItem>
  locations?: OrderLocation[]
}

export interface OrderLocation {
  locationId: string
  orderType?: string
  transportId?: string
}

export enum CartMode {
  MULTI_VEHICLE = 'multi-vehicle',
  SINGLE_VEHICLE = 'single-vehicle',
  CART_ONLY = 'cart-only',
}

/**
 * @deprecated Not used in the multi seller code. Use {@link CartProduct} instead.
 */
export interface ShoppingCartProduct extends ProductModel {
  activeLocationId?: string
  orderSelections?: Array<OrderSelection>
  errors?: Array<AvailabilityError>
}

/**
 * @deprecated Not used in the multi seller code.
 */
export interface OrderSelection {
  locationId: string
  // orderType?: string
  // transportId?: string
  quantityRequested: number
}

export interface OrderFormData {
  poNumber: string
  noteToStore: string
  customerName: string
  personalNote: string
  shipToAddress?: string //This is the stringified index of the address in addresses array
}

export interface SelectedLocationTransports {
  locationId: string
  transport: Transport
}

export interface CartPartDetails {
  shoppingCartProduct: ShoppingCartProduct
  yourCost?: number
  selectedLocation?: ProductLocationModel
  total?: number
}
export interface TransferPart {
  unitPrice: string
  manufacturerPartId: string
  selectedLoc: string
  classificationDomain: string
  unitCore: string
  categoryCodeIdentifier: string
  manufacturerName: string
  lineCode: string
  uom: string
  packNumUnits: string
  partDescription: string
  lineType: string
  qty: string
  partNumber: string
  currency: string
}

export interface TransferPartsData {
  partsdata: Array<TransferPart>
}

export interface TransferPartsDataResponse {
  data: string
  returnUrl: string
  status: string
}

export interface CxmlDetails {
  cxmlData: boolean
  token: string
}
